import React from 'react'
import PropTypes from 'prop-types'

const ChartIcon = ({width, height}) =>  (
    <svg className="icon"  width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-224.000000, -412.000000)" fill="#999999" fillRule="nonzero" id="Shape">
                <path d="M231.689697,430.342201 C232.321484,430.307886 232.947119,430.237349 233.565137,430.130003 L233.565137,436 L231.689697,436 L231.689697,430.342201 Z M224,436 L225.875586,436 L225.875586,430.367131 L224,430.367131 L224,436 Z M227.844922,430.367131 L227.844922,436 L229.720361,436 L229.720361,430.367131 L227.844922,430.367131 Z M243.177148,436 L245.052734,436 L245.052734,421.7277 C244.528467,422.731648 243.901953,423.67415 243.177148,424.546408 L243.177148,436 Z M239.33252,436 L241.207812,436 L241.207812,426.539784 C240.61499,427.044984 239.988916,427.504137 239.33252,427.916069 L239.33252,436 Z M235.487598,429.67129 L235.487598,436 L237.363184,436 L237.363184,428.967823 C237.262549,429.01299 237.161475,429.057571 237.059668,429.100539 C236.543604,429.319043 236.019043,429.508952 235.487598,429.67129 L235.487598,429.67129 Z M244.05459,412 L240.075928,415.98294 L241.402197,417.310684 L243.051465,415.659583 C242.357715,421.813342 237.12793,426.611788 230.798633,426.611788 L224,426.611788 L224,428.48946 L230.798633,428.48946 C234.593604,428.48946 238.161377,427.009935 240.844824,424.323504 C243.223438,421.942245 244.654004,418.864559 244.948145,415.550037 L246.67373,417.277542 L248,415.949798 L244.05459,412 Z"></path>
            </g>
        </g>
    </svg>
)

ChartIcon.defaultProps = {
    width: 24,
    height: 24
}

ChartIcon.prototype = {
    width: PropTypes.string,
    height: PropTypes.string
}

export default ChartIcon;